// Module
var code = "<div class=\"Coverage\"> <sub-nav class=\"Coverage__subNav\" ng-if=\"Coverage.subNavLinks.length > 1\" data-links=\"Coverage.subNavLinks\"> </sub-nav> <ui-view name=\"coverageContent\"></ui-view> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/coverage/coverage.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;